import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import spinner from '../assets/spinner.gif';

const LoadingSpinnerComponent = styled.div<{ $minimal: boolean }>(({ theme, $minimal }) => `
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: ${!$minimal && 'rgba(0, 0, 0, 0.3)'};

  .modal-content {
    border-radius: 10px;
    border: ${$minimal ? 'none' : '2px solid #e4e4e4'};
    background-color: ${$minimal ? 'rgba(0, 0, 0, 0)' : theme.palette.primary.contrastText};
    padding: 40px;
    box-sizing: border-box;
    box-shadow: ${$minimal ? 'none' : '0px 0px 5px 0px rgba(0, 0, 0, 0.25)'};
    color: ${theme.palette.text.primary};
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: inline-flex;
  }

  p {
    margin: 10px 18px 10px 18px;
  }
`);

interface LoadingSpinnerProps {
  minimal?: boolean;
}

export default function LoadingSpinner({ minimal = false }: Readonly<LoadingSpinnerProps>) {
  const { t } = useTranslation();
  return (
    <LoadingSpinnerComponent $minimal={minimal}>
      <div className="modal-content" data-testid="loading-spinner">
        <img alt="Loading..." src={spinner} height="42px" width="42px" />
        {!minimal && (
          <p>{t('Loading.Message')}</p>
        )}
      </div>
    </LoadingSpinnerComponent>
  );
}
